export const toAbsoluteUrl = (pathname: string) =>
  import.meta.env.BASE_URL + pathname;